// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { useParams } from '@tanstack/react-router';

// material ui
import { Alert, AlertTitle, Box } from '@mui/material';

// api
import { useGetEnergyGroupQuery } from '@/api/generated/recalc/endpoints/v2/energyGroups';

// relative
import ESGPage from './ESGPage';
import ESGWaterHeatPage from './ESGWaterHeatPage';

/**
 * Router component that renders the appropriate ESG page based on energy group type
 * - Power groups (Portfolio) -> ESGPage with location/municipality/market modes
 * - Water/Heat groups (PortfolioWater/PortfolioHeat) -> ESGWaterHeatPage (simplified)
 */
const ESGRouter = () => {
  const { energyGroupId } = useParams({ strict: false });
  const { data: selectedEnergyGroup } = useGetEnergyGroupQuery(
    { groupId: energyGroupId },
    { skip: !energyGroupId },
  );
  const { t } = useTranslation('energyxplorer-esg');
  if (selectedEnergyGroup?.energyTreeNodes?.length > 250) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">
          <AlertTitle>{t('tooManyNodes.title') || 'Too Many Nodes'}</AlertTitle>
          {t('tooManyNodes.description') ||
            'This energy group has too many nodes to display the ESG data. Please select a different energy group with fewer than 250 nodes.'}
        </Alert>
      </Box>
    );
  }

  // Determine if this is a water or heat portfolio
  const isWaterOrHeat =
    selectedEnergyGroup?.type === 'PortfolioWater' ||
    selectedEnergyGroup?.type === 'PortfolioHeat' ||
    selectedEnergyGroup?.type === 'Water' ||
    selectedEnergyGroup?.type === 'Heat';
  // Route to appropriate component
  if (isWaterOrHeat) {
    return <ESGWaterHeatPage />;
  }

  return <ESGPage />;
};

export default ESGRouter;
